export default __webpack_public_path__ + "static/media/ont-huawei.32cb1bd2.png";